import { PROJECT_TAB_LIST } from 'components/HeaderProject/constant'

export const forwardToDefaultTaskView = (taskView) => {
  const tab = PROJECT_TAB_LIST.find(tab => tab.id === taskView);
  return tab?.to;
}